import { useCallback } from "react";
import { useAnalytics } from "~/components/Analytics";
import { useSyncPermissions } from "~/components/Piano/useSyncPermissions";
import { PianoOffer } from "~/types/endil/subscription";

type UsePostCheckoutHandler = {
  pianoOffer: PianoOffer;
  /** User's current session */
  mcAccountId: string | undefined;
};

export const usePostCheckoutHandler = ({
  pianoOffer,
  mcAccountId,
}: UsePostCheckoutHandler) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const syncPermissions = useSyncPermissions();

  return useCallback(async () => {
    analyticsEnhancedTrack("Subscription Checkout Completed", {
      subscription: { ...pianoOffer },
    });

    const hasProFullAccessAfterRefresh = await syncPermissions(true);
    if (!hasProFullAccessAfterRefresh) {
      throw new Error(
        `failed to grant pro access for user_id ${mcAccountId} after Piano checkout was completed`
      );
    }
  }, [analyticsEnhancedTrack, mcAccountId, pianoOffer, syncPermissions]);
};
